globalThis.appVisitor = globalThis.appVisitor || {};

(function($) {
    $.fn.animateElement = function(options)
    {
        var animation_type = options.type;
        var $this = this;
        if(!$this.hasClass('animated')) {
          $this
              .css('-webkit-animation-duration', options.duration + 'ms')
              .css('animation-duration', options.duration + 'ms')
              .addClass('animated ' + animation_type)
              .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                  $this.removeClass(animation_type);
                  ImageQueries.refresh($this);
              });
        }
    }
})(jQuery);

appVisitor.Animations = (function()
{
    function Animations() {}

    var animationDefaults = {
      type: "fadeIn",
      duration: 200,
      delay: 0
    }

    $.fn.getAnimationOptions = function()
    {
        var $this = $(this);
        var animationOptions = $this.data('animation-options');
        return $.extend( animationDefaults, animationOptions );
    }

    Animations.init = function($html)
    {
      if(!jQuery.browser.mobile)
      {
        var $animatedElements = appVisitor.Animations.getAnimatedElements($html);

        appVisitor.Animations.initAnimationsListenner($animatedElements);
        $(window).scroll();
      }
    }

    Animations.initAnimationsListenner = function($elements)
    {
      var timeout = false;
      $(window).on('resize scroll', function()
      {
        if(!timeout) {
          timeout = setTimeout(function() {
            elementsToAnimate = appVisitor.Animations.getVisibleAnimatedElements($elements);
            appVisitor.Animations.animateElements(elementsToAnimate);
            timeout = false;
          }, 200);
        }
      });
      $(window).on('beforeChange.slick', function(event, slick, current_slide_index, next_slide_index) {
        appVisitor.Animations.restoreElementsFromHTML(slick.$slider);
      });
      $(window).on('afterChange.slick', function(event, slick, current_slide_index) {
        setTimeout(function() {
          $currentSlide = $(slick.$slides[current_slide_index]);
          appVisitor.Animations.animateElementsFromHTML($currentSlide);
        }, 400);
      });
    }

    Animations.animateElementsFromHTML = function($html)
    {
      elementsToAnimate = appVisitor.Animations.getAnimatedElements($html);
      appVisitor.Animations.animateElements(elementsToAnimate);
    }
    Animations.restoreElementsFromHTML = function($html)
    {
        elementsToRestore = appVisitor.Animations.getAnimatedElements($html);
        appVisitor.Animations.restoreElements(elementsToRestore);
    }

    Animations.getAnimatedElements = function($html)
    {
        if($html === undefined) {
          $html = $('body');
        }
        return $html.find('.sb-display-animated');
    }

    Animations.getVisibleAnimatedElements = function($elements)
    {
        result = [];
        $elements.each(function() {
          var $this = $(this);
          if($this.isScrolledIntoView()) {
            result.push($this);
          }
        });
        return result;
    }

    Animations.animateElements = function(elementsToAnimate)
    {
        $.each( elementsToAnimate, function( key, elementToAnimate ) {
            var $this = $(elementToAnimate);
            if(!$this.hasClass('animated'))
            {
              var animationOptions = $this.getAnimationOptions();
              setTimeout(function() {
                  var animationOptions = $this.getAnimationOptions();
                  $this.animateElement(animationOptions);
              }, animationOptions.delay);
            }
        });
    }

    Animations.restoreElements = function(elementsToRestore)
    {
        $.each( elementsToRestore, function( key, elementToRestore ) {
            var $this = $(elementToRestore);
            var animationOptions = $this.getAnimationOptions();
            $this.removeClass('animated ' + animationOptions.type);
        });
    }

    Animations.prototype = {}

    return Animations;
})();
